// extracted by mini-css-extract-plugin
export default {"card":"OZ-z","carouselContainer":"PZ-z","carouselContent":"QZ-z"};